<template>
  <div
    class="silder-contain slider-activitiesManage"
    :class="aciveInfo.aciveClass"
  >
    <div class="slider-top clearFloat">
      <p class="h3 slider-title pull-left">{{ aciveInfo.aciveText }}</p>
      <div class="pull-right h1 btn-close font-gray" @click="hideSliderBox">
        <i class="el-icon-close"></i>
      </div>
      <el-button
        type="primary"
        v-if="!isEdit"
        class="pull-right"
        @click="onSubmit"
        >{{ $t("active.confirmPublish") }}</el-button
      >
      <el-button type="primary" v-else class="pull-right" @click="onSubmit">{{
        $t("active.confirmEdit")
      }}</el-button>
    </div>
    <div class="slider-cont text-1">
      <el-form ref="form" :model="form" :rules="rules" label-width="180px">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :disabled="infomationData.activity_type == 1"
            :label="$t('active.baseInfo')"
            name="first"
          >
            <el-form-item :label="$t('active.activeName')" prop="activity_name">
              <el-input
                v-model="form.activity_name"
                style="width: 412px"
                :placeholder="$t('active.activeNamePlaceHold')"
              ></el-input>
              <span class="tip-text">
                <i class="tip-icon">!</i>
                {{ $t("active.nameOnly") }}
              </span>
            </el-form-item>
            <!-- // company_ismajor  0是免费版 1是普通版   2是专业版 -->
            <!-- 2020/01/20 需求 暂时隐藏 -->

            <!-- <el-form-item :label="$t('active.activeType')" prop="activity_pattern">
              <el-radio-group v-model="form.activity_pattern">
                <el-radio :label="0" class="isdefault">{{$t('active.normal')}}</el-radio>
                <el-radio
                  v-if="companyIsmajor=='2'"
                  :label="1"
                  class="isdefault"
                >{{$t('active.EnrollmentStu')}}</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item
              :label="$t('active.activeTopic')"
              prop="activity_theme"
            >
              <el-input
                v-model="form.activity_theme"
                style="width: 412px"
                :placeholder="$t('active.activeTopicPlaceHold')"
              ></el-input>
            </el-form-item>
            <div class="active-time">
              <el-form-item :label="$t('active.activeTime')" prop="times">
                <el-date-picker
                  v-model="form.times"
                  style="width: 412px"
                  type="datetimerange"
                  :range-separator="$t('Common.to')"
                  :start-placeholder="$t('active.activeStartTime')"
                  :end-placeholder="$t('active.activeEndTime')"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  @change="timesChange"
                ></el-date-picker>
              </el-form-item>
              <span class="tip-text">
                <i class="tip-icon">!</i>
                {{ $t("active.activeEnd") }}
              </span>
            </div>
            <el-form-item
              :label="$t('active.channelType')"
              prop="frommedia_name"
            >
              <el-select
                @change="frommediaSearch"
                v-model="form.frommedia_name"
                style="width: 412px"
                :placeholder="$t('active.channelTypePlaceHold')"
                clearable
                filterable
              >
                <el-option
                  v-for="item in SourceList"
                  :key="item.frommedia_id"
                  :label="item.frommedia_name"
                  :value="item.frommedia_name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('active.channelDetail')" prop="channel_id">
              <el-select
                v-model="form.channel_id"
                style="width: 412px"
                :placeholder="$t('active.channelDetailPlaceHold')"
              >
                <el-option
                  v-for="item in ChannelList"
                  :key="item.channel_id"
                  :label="item.channel_name"
                  :value="item.channel_id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="是否需选择性别："
              prop="activity_issex"
              :rules="[{ required: true, message: '是否需选择性别' }]"
            >
              <el-radio-group
                @change="() => (form.activity_issex_must = 0)"
                v-model="form.activity_issex"
              >
                <el-radio :label="1" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk1s0") }}
                </el-radio>
                <el-radio :label="0" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk640") }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.activity_issex == 1"
              label="性别是否必填："
              prop="activity_issex_must"
              :rules="[{ required: true, message: '性别是否必填' }]"
            >
              <el-radio-group v-model="form.activity_issex_must">
                <el-radio :label="1" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk1s0") }}
                </el-radio>
                <el-radio :label="0" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk640") }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="是否需选择出生日期："
              prop="activity_isbirthday"
              :rules="[{ required: true, message: '是否需选择出生日期' }]"
            >
              <el-radio-group
                @change="() => (form.activity_isbirthday_must = 1)"
                v-model="form.activity_isbirthday"
              >
                <el-radio :label="1" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk1s0") }}
                </el-radio>
                <!-- <el-radio :label="0" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk640") }}
                </el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="出生日期是否必填："
              prop="activity_isbirthday_must"
              :rules="[{ required: true, message: '出生日期是否必填' }]"
              v-if="form.activity_isbirthday == 1"
            >
              <el-radio-group v-model="form.activity_isbirthday_must">
                <el-radio :label="1" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk1s0") }}
                </el-radio>
                <!-- <el-radio :label="0" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk640") }}
                </el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="是否需选择联系地址："
              prop="activity_isaddress"
              :rules="[{ required: true, message: '是否需选择联系地址' }]"
            >
              <el-radio-group
                @change="() => (form.activity_isaddress_must = 0)"
                v-model="form.activity_isaddress"
              >
                <el-radio :label="1" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk1s0") }}
                </el-radio>
                <el-radio :label="0" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk640") }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="联系地址是否必填："
              prop="activity_isaddress_must"
              :rules="[{ required: true, message: '联系地址是否必填' }]"
              v-if="form.activity_isaddress == 1"
            >
              <el-radio-group v-model="form.activity_isaddress_must">
                <el-radio :label="1" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk1s0") }}
                </el-radio>
                <el-radio :label="0" class="isdefault">
                  {{ $t("views.Customersmanage.custoMersmanage.5zlnqvcgk640") }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('active.activeTemlate')">
              <el-radio-group
                v-model="form.activity_istemp"
                @change="selcetTemp(form.activity_istemp)"
              >
                <el-radio :label="1" class="isdefault">{{
                  $t("active.systemTemlate")
                }}</el-radio>
                <el-radio :label="0" class="isdefault">{{
                  $t("active.customTemlate")
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label v-if="form.activity_istemp == '1'">
              <el-select
                v-model="form.activitytemp_id"
                style="width: 412px"
                :placeholder="$t('active.selectTemlate')"
                @change="activitytempChange()"
              >
                <el-option
                  v-for="(item, index) in ActivitytempOption"
                  :key="index"
                  :label="item.activitytemp_name"
                  :value="item.activitytemp_id"
                ></el-option>
              </el-select>
              <el-button
                v-if="form.activitytemp_id != ''"
                type="text"
                class="btn-review"
                @click="perviewTemp()"
                >{{ $t("active.previewTemlate") }}</el-button
              >
            </el-form-item>
            <el-form-item label v-if="form.activity_istemp == '0'">
              <el-input
                type="text"
                v-model="form.activity_tempurl"
                style="width: 412px"
                :placeholder="$t('active.urlPlaceHold')"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="地推模式"
              prop="activity_codetype"
              :rules="[{ required: true, message: '请选择地推模式' }]"
            >
              <el-radio-group v-model="form.activity_codetype">
                <el-radio label="0" class="isdefault"> 地推码 </el-radio>
                <!-- <el-radio label="1" class="isdefault"> 企微地推码 </el-radio> -->
              </el-radio-group>
            </el-form-item>

            <el-form-item
              v-if="form.activity_codetype == 0"
              label="配置有赞课包"
              prop="package_branch"
            >
              <el-select
                v-model="form.package_branch"
                style="width: 400px"
                placeholder="请选择配置有赞课包"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in packageList"
                  :key="index"
                  :label="item.package_name"
                  :value="item.package_branch"
                ></el-option>
              </el-select>
              <p class="color-blue">注:若配置课包，用户留名单后将自动跳转课包商品页可进行购买</p>
            </el-form-item>

            <el-form-item :label="$t('active.phone')">
              <el-input
                type="text"
                v-model="form.activity_contacttel"
                style="width: 412px"
                :placeholder="$t('active.phonePlaceHold')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('active.address')">
              <el-input
                type="text"
                v-model="form.activity_address"
                style="width: 412px"
                :placeholder="$t('active.addressPlaceHold')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('active.activeWHTopic')">
              <el-input
                v-model="form.activity_imgwidth"
                style="width: 190px"
                :placeholder="$t('active.activeWPlaceHold')"
              ></el-input>
              <span style="margin: 0 13px">-</span>
              <el-input
                v-model="form.activity_imgheight"
                style="width: 190px"
                :placeholder="$t('active.activeHPlaceHold')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('active.fileImg')">
              <div class="uplode-div active-upload">
                <el-upload
                  class="avatar-uploader"
                  :action="$uploadAction('/Uploading/Picture')"
                  name="ossfile"
                  :data="Uploadeimg"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <div v-else>
                    <i class="el-icon-plus"></i>
                    <div class="el-upload__text">
                      {{ $t("active.fileImgPlaceHold") }}
                    </div>
                  </div>
                </el-upload>
              </div>
              <el-button
                v-if="imageUrl"
                type="text"
                class="btn-review"
                @click="perviewSeeTemp()"
                >{{ $t("active.viewPriew") }}</el-button
              >
            </el-form-item>
            <el-form-item :label="$t('active.activeDetail')">
              <!-- <el-input
                type="textarea"
                v-model="form.activity_content"
                style="width: 412px;"
                placeholder="请输入活动详情"
              ></el-input>-->
              <VueNeditorWrap
                ref="ueditor"
                v-model="form.activity_content"
                :destroy="false"
                :config="config"
                style="width: 412px"
                @ready="loadUeditor"
              ></VueNeditorWrap>
            </el-form-item>
            <el-form-item :label="$t('active.activeRule')">
              <!-- <el-input
                type="textarea"
                v-model="form.activity_rule"
                style="width: 412px;"
                :placeholder="$t('active.activeRulePlaceHold')"
              ></el-input> -->
              <VueNeditorWrap
                ref="ueditor"
                v-model="form.activity_rule"
                :destroy="false"
                :config="config"
                style="width: 412px"
                @ready="loadUeditor"
              ></VueNeditorWrap>
            </el-form-item>
            <el-form-item :label="$t('active.shareDescrible')">
              <el-input
                type="textarea"
                v-model="form.activity_sharedesc"
                style="width: 412px"
                :placeholder="$t('active.shareDescriblePlaceHold')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('active.shareImg')" class="upload-share">
              <el-upload
                class="avatar-share-img"
                :action="$uploadAction('/Uploading/Picture')"
                name="ossfile"
                :data="UploadeimgTwo"
                :show-file-list="false"
                :on-success="handleAvatarSuccessTwo"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrlTwo" :src="imageUrlTwo" class="avatar" />
                <div v-else class="share-text">
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__text">
                    {{ $t("active.shareImgPlaceHold") }}
                  </div>
                </div>
              </el-upload>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane
            :disabled="infomationData.activity_type == 1"
            :label="$t('active.aboutUs')"
            name="second"
          >
            <VueNeditorWrap
              ref="ueditor"
              v-model="form.activity_aboutus"
              :destroy="false"
              :config="config"
              @ready="loadUeditor"
            ></VueNeditorWrap>
          </el-tab-pane>
          <el-tab-pane
            :disabled="infomationData.activity_type == 1"
            :label="$t('active.CustomDetails')"
            name="third"
          >
            <VueNeditorWrap
              ref="ueditor"
              v-model="form.activity_customcontent"
              :destroy="false"
              :config="config"
              @ready="loadUeditor"
            ></VueNeditorWrap>
          </el-tab-pane>
          <el-tab-pane
            v-if="JSON.stringify(infomationData) != '{}'"
            :disabled="infomationData.activity_type == 1"
            label="适配班种"
            name="six"
          >
            <div class="flex-all mb10">
              <span> 适配班种数量：{{ classTableData.list.length }} </span>
              <el-button type="primary" size="mini" @click="addClass">
                添加班种
              </el-button>
            </div>
            <div class="graden-table" ref="auto_height_class_table">
              <noBorderTableCont :tableData="classTableData">
                <!-- 按钮操作组********start -->
                <el-table-column
                  ref="fixedColumn"
                  label="操作"
                  align="center"
                  width="120px"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click.native.prevent="delClass(scope.row)"
                    >
                      移除
                    </el-button>
                  </template>
                </el-table-column>
                <!-- 按钮操作组********end -->
              </noBorderTableCont>
            </div>
          </el-tab-pane>
          <el-tab-pane label="地推人员" name="five">
            <div class="groundPromotion-manage-tabpane">
              <span class="groundPromotion-manage-tabpane-tips"
                >注：地推人员仅用于地推二维码的生成</span
              >
              <div>
                <noBorderTableCont
                  ref="promotion"
                  :tableData="promotionTableList"
                  @handleSelectionChange="handleSelectionChange"
                >
                </noBorderTableCont>
              </div>
              <!-- <div class="groundPromotion-manage-tabpane-title">地推人员</div>
              <div class="groundPromotion-manage-tabpane-wrapper">
                <el-form
                  label-width="150px"
                  :model="formData"
                  status-icon
                  ref="formData"
                  style="margin-left: 0px !important"
                >
                  <div v-for="(item, index) in formData.codeList" :key="index">
                    <el-form
                      :model="item"
                      :ref="`Setup${index}`"
                      class="code_list"
                    >
                      <div>
                        <div class="flex">
                          <el-form-item
                            prop="promotion_name"
                            :rules="[
                              {
                                required: true,
                                message: '请输入姓名',
                              },
                            ]"
                          >
                            <el-input
                              v-model="item.promotion_name"
                              clearable
                              placeholder="请输入姓名"
                              style="width: 130px"
                              class="mr20"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="promotion_mobile"
                            :rules="[
                              {
                                required: true,
                                trigger: 'blur',
                                validator: checkPhone,
                              },
                            ]"
                          >
                            <el-input
                              @blur="getPromotion(item.promotion_mobile, index)"
                              v-model="item.promotion_mobile"
                              clearable
                              placeholder="请输入手机号"
                              style="width: 160px"
                              class="mr20"
                              :disabled="item.disabled"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="promotion_jobnumber"
                            :rules="[
                              {
                                required: true,
                                trigger: 'blur',
                                validator: checkJobnumber,
                              },
                            ]"
                            class="mr20"
                          >
                            <el-input
                              @blur="getJobnumber(item.promotion_jobnumber)"
                              v-model="item.promotion_jobnumber"
                              clearable
                              placeholder="请输入地推工号"
                              style="width: 160px"
                            ></el-input>
                          </el-form-item>

                          <el-form-item
                            prop="promotion_type"
                            :rules="[
                              {
                                required: true,
                                message: '请选择地推类型',
                              },
                            ]"
                          >
                            <el-select
                              placeholder="请选择地推类型"
                              v-model="item.promotion_type"
                              style="width: 160px"
                            >
                              <el-option label="市场" value="0"></el-option>
                              <el-option label="销售" value="1"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="flex">
                          <el-form-item
                            prop="promotion_bankcard"
                            :rules="[
                              {
                                required: false,
                                message: '请输入银行卡号',
                              },
                            ]"
                          >
                            <el-input
                              v-model="item.promotion_bankcard"
                              clearable
                              placeholder="请输入银行卡号"
                              style="width: 140px"
                              class="mr20"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="promotion_bank"
                            :rules="[
                              {
                                required: false,
                                message: '请输入开户行',
                              },
                            ]"
                          >
                            <el-input
                              v-model="item.promotion_bank"
                              clearable
                              placeholder="请输入开户行"
                              style="width: 150px"
                              class="mr20"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>

                      <span
                        class="code-remove"
                        @click="delItem(index)"
                        v-if="formData.codeList.length > 1"
                      >
                        <i class="el-icon-remove-outline"></i>
                      </span>
                    </el-form>
                  </div>
                  <div class="add-icon" @click="addItem">
                    <i class="el-icon-circle-plus"></i>
                    <span>继续添加</span>
                  </div>
                </el-form>
              </div> -->
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
  </div>
</template>

<script>
// 1、引入VueUeditorWrap组件
import VueNeditorWrap from "vue-neditor-wrap";
import storeActive from "./active.js";
import noBorderTableCont from "@/components/tables/noBorderTableCont.vue";
import CrmActiveManage from "@/views/Crmactivemanage/crmActiveManage.js";

export default {
  name: "active",
  props: ["aciveInfo", "showSliderBox", "isEdit", "infomationData"],
  data() {
    var checkPhone = (rule, value, callback) => {
      CrmActiveManage.getPromotion({
        promotion_mobile: value,
      }).then((res) => {
        if (!value) {
          return callback(new Error("手机号不能为空"));
        } else {
          const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
          if (reg.test(value)) {
            if (res.data.code !== 200) {
              return callback(new Error("用户已存在"));
            } else {
              callback();
            }
          } else {
            return callback(new Error("请输入正确的手机号"));
          }
        }
      });
    };
    var checkJobnumber = (rule, value, callback) => {
      CrmActiveManage.getPromotion({
        promotion_jobnumber: value,
      }).then((res) => {
        if (!value) {
          return callback(new Error("地推工号不能为空"));
        } else {
          if (res.data.code !== 200) {
            return callback(new Error("地推工号已存在"));
          } else {
            callback();
          }
        }
      });
    };
    return {
      checkPhone,
      checkJobnumber,
      activeName: "first",

      packageList: [],
      // 侧边栏 资料建档
      form: {
        activity_name: "", //活动名称
        activity_pattern: 0, //活动类型
        activity_theme: "", //活动主题
        activity_imgwidth: "750", // 主图宽
        activity_imgheight: "320", //主图高
        times: [], //时间
        activity_starttime: "", //开始时间
        activity_endtime: "", //结束时间
        activity_istemp: 1, //是否使用招生模板
        activitytemp_id: "", //招生模板id
        activity_tempurl: "", //自定义招生模板链接
        activity_contacttel: "", //联系方式
        activity_codetype: "0",
        package_branch: "",
        activity_address: "", //活动地址
        activity_img: "", //主图
        activity_content: "", //活动详情
        activity_rule: "", //活动规则
        activity_sharedesc: "", //分享描述
        activity_shareimg: "", //分享小图片
        activity_aboutus: "", //关于我们
        activity_customcontent: "", //自定义详情
        frommedia_name: "", //来源聚道类型
        channel_id: "", //招生渠道明细

        activity_issex: 1,
        activity_issex_must: 0,
        activity_isbirthday: 1,
        activity_isbirthday_must: 1,
        activity_isaddress: 1,
        activity_isaddress_must: 0,
      },
      imageUrl: "",
      Uploadeimg: {
        company_id: "",
        ossfile: "",
      },
      imageUrlTwo: "", //上传banner图
      UploadeimgTwo: {
        company_id: "",
        ossfile: "",
      },
      ActivitytempOption: [], //模板
      SourceList: [], //招生渠道类型
      ChannelList: [], //招生渠道明细
      ActivitytempOne: {}, //单个模板信息
      config: {
        UEDITOR_HOME_URL: "/NEditor/",
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        wordCount: false,
        elementPathEnabled: false,
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: this.$uploadAction('/Uploading/Picture'),
        toolbars: [
          [
            // "insertimage",
            // "insertvideo",
            // 'insertcode',
            "source",
            "justifyleft",
            "justifyright",
            "justifycenter",
            "justifyjustify",
            "fontfamily",
            "fontsize",
            "forecolor",
            "backcolor",
          ],
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerOptionsStartCreate: {
        disabledDate: (time) => {
          if (this.form.activity_endtime && !this.isEdit) {
            return (
              time.getTime() < new Date(this.form.activity_endtime).getTime()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsEndCreate: {
        disabledDate: (time) => {
          if (this.form.activity_starttime && !this.isEdit) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.form.activity_starttime).getTime()
            );
          } else {
            if (this.isEdit) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.form.activity_starttime).getTime()
              );
            } else {
              return (
                time.getTime() > Date.now() - 8.64e7 ||
                time.getTime() >
                  new Date(this.form.activity_starttime).getTime()
              );
            }
          }
        },
      },
      // 表单验证
      rules: {
        activity_name: [
          {
            required: true,
            message: this.$t("active.rule_tips3"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 50,
            message: this.$t("active.rule_tips4"),
            trigger: "blur",
          },
        ],
        activity_pattern: [
          {
            required: true,
            message: this.$t("active.rule_tips5"),
            trigger: "change",
          },
        ],
        times: [
          {
            required: true,
            message: this.$t("active.rule_tips6"),
            trigger: "change",
          },
        ],
        activity_theme: [
          {
            required: true,
            message: this.$t("active.rule_tips7"),
            trigger: "blur",
          },
        ],
        activity_endtime: [
          {
            required: true,
            message: this.$t("active.rule_tips8"),
            trigger: "change",
          },
        ],
        frommedia_name: [
          {
            required: true,
            message: this.$t("active.rule_tips9"),
            trigger: "change",
          },
        ],
        channel_id: [
          {
            required: true,
            message: this.$t("active.rule_tips10"),
            trigger: "change",
          },
        ],
        // activity_contacttel: [
        //   {
        //     required: true,
        //     message: this.$t('active.rule_tips11'),
        //     trigger: "blur"
        //   }
        // ]
        // activity_contacttel: [{ validator: checkPhone, trigger: "blur" }]
      },
      // 表格数据
      promotionTableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: true, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: 700,
        },
      },
      formData: {
        codeList: [
          {
            promotion_name: "",
            promotion_mobile: "",
            promotion_jobnumber: "",
            promotion_type: "0",
            promotion_bankcard: "",
            promotion_bank: "",
          },
        ],
      },
      promotionSelectList: [],

      classTableData: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: "0px", //表格高度
        },
        // 分页
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  components: {
    VueNeditorWrap,
    noBorderTableCont,
  },
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.Uploadeimg.company_id = this.company_id;
    this.UploadeimgTwo.company_id = this.company_id;
    this.ActivitytempApi();
    this.getSourceTwoApi(); // 获取渠道类型
    this.getChannelTwoApi(); // 获取渠道明细
    //   编辑
    this.showInformation(); // 显示编辑的信息
    this.getGroundPromotion();
    this.activityPackageListApi();

    if (this.infomationData.activity_type == 1) {
      this.activeName = "five";
    }
  },
  watch: {
    getshowSliderBox(n) {
      if (!n) {
        // 清空数据
        this.resetForm();
      } else {
        this.showInformation(); // 显示编辑的信息
      }
    },
  },
  computed: {
    getshowSliderBox() {
      return this.showSliderBox;
    },
    companyIsmajor() {
      return this.$store.state.companyIsmajor; //0是免费版 1是普通版   2是专业版
    },
  },
  methods: {
    activityPackageListApi() {
      storeActive.activityPackageListApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        this.packageList = code === 200 ? data.list : [];
      });
    },
    addClass() {
      (() => {})(this.infomationData.activity_id);
      this.$emit("handleAddClass");
    },
    delClass(v) {
      this.$emit("handleRemoveClass", v);
    },

    // 招生目标->活动招生模板管理
    ActivitytempApi() {
      storeActive
        .ActivitytempApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.ActivitytempOption = (res.data.data.data || []).filter(item => item != null);
          if (!this.isEdit && this.ActivitytempOption.length > 0) {
            this.form.activitytemp_id = this.ActivitytempOption[0].activitytemp_id;
            this.ActivitytempOneApi();
          }
        });
    },
    //招生目标->单个招生模板的信息************
    ActivitytempOneApi() {
      storeActive
        .ActivitytempOneApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          activitytemp_id: this.form.activitytemp_id,
        })
        .then((res) => {
          this.ActivitytempOne = res.data.data.data;
        });
    },
    // 获取渠道类型
    getSourceTwoApi() {
      this.$http.getSourceTwoApi({}).then((res) => {
        this.SourceList = res.data.data.list;
      });
    },
    // 获取渠道明细
    getChannelTwoApi() {
      this.$http
        .getChannelTwoApi({
          channel_medianame: this.form.frommedia_name,
        })
        .then((res) => {
          this.ChannelList = res.data.data.list;
        });
    },
    // 选择系统模板
    activitytempChange() {
      this.ActivitytempOneApi();
    },
    // 选择活动时间
    timesChange() {
      if (this.form.times) {
        if (this.form.times[0] === this.form.times[1]) {
          this.form.times = "";
          this.$message({
            message: this.$t("active.rule_tips12"),
            type: "error",
          });
        } else {
          this.form.activity_starttime = this.form.times[0];
          this.form.activity_endtime = this.form.times[1];
        }
      } else {
        this.$set(this.form, "times", []);
        this.form.activity_starttime = "";
        this.form.activity_endtime = "";
      }
      (() => {})(this.form.times);
    },
    hideSliderBox() {
      this.$emit("hideSliderBox");
    },
    // 预览模版
    perviewTemp() {
      this.$emit("perviewTemp", this.ActivitytempOne);
    },
    // 查看预览图
    perviewSeeTemp() {
      this.$emit("perviewSeeTemp", this.ActivitytempOne);
    },
    // 显示编辑的信息
    showInformation() {
      this.activeName = "first"; //初始化
      //   编辑
      if (this.isEdit) {
        let value = this.infomationData;
        this.ActivitytempOne = this.infomationData;
        this.form = {
          activity_name: value.activity_name, //活动名称
          activity_theme: value.activity_theme, //活动主题
          activity_imgwidth: value.activity_imgwidth, // 主图宽
          activity_imgheight: value.activity_imgheight, //主图高
          activity_pattern: parseInt(value.activity_pattern), //活动类型
          activity_starttime: value.activity_starttime, //开始时间
          activity_endtime: value.activity_endtime, //结束时间
          activity_istemp: parseInt(value.activity_istemp), //是否使用招生模板
          activitytemp_id: value.activitytemp_id, //招生模板id
          activity_tempurl: value.activity_tempurl, //自定义招生模板链接
          activity_contacttel: value.activity_contacttel, //联系方式
          activity_codetype: value.activity_codetype,
          package_branch: value.package_branch,
          activity_address: value.activity_address, //活动地址
          activity_img: value.activity_img, //主图
          activity_content: !value.activity_content
            ? ""
            : value.activity_content, //活动详情
          activity_rule: !value.activity_rule ? "" : value.activity_rule, //活动规则
          activity_sharedesc: value.activity_sharedesc, //分享描述
          activity_shareimg: value.activity_shareimg, //分享小图片
          activity_aboutus: !value.activity_aboutus
            ? ""
            : value.activity_aboutus, //关于我们
          activity_customcontent: !value.activity_customcontent
            ? ""
            : value.activity_customcontent, //自定义详情
          frommedia_name: value.frommedia_name, //来源聚道名称
          channel_id: value.channel_id, //招生渠道明细

          activity_issex: parseInt(value.activity_issex),
          activity_issex_must: parseInt(value.activity_issex_must),
          activity_isbirthday: parseInt(value.activity_isbirthday),
          activity_isbirthday_must: parseInt(value.activity_isbirthday_must),
          activity_isaddress: parseInt(value.activity_isaddress),
          activity_isaddress_must: parseInt(value.activity_isaddress_must),
        };
        this.form.times = [value.activity_starttime, value.activity_endtime];
        this.form = JSON.parse(JSON.stringify(this.form));
        this.imageUrl = value.activity_img;
        this.imageUrlTwo = value.activity_shareimg;
      } else {
        this.resetForm();
      }
    },
    // 表单清空
    resetForm() {
      // 清空数据
      this.form = {
        activity_name: "", //活动名称
        activity_theme: "", //活动主题
        activity_imgwidth: "750", // 主图宽
        activity_imgheight: "320", //主图高
        activity_pattern: 0, //活动类型
        range_time: "", //时间范围
        activity_starttime: "", //开始时间
        activity_endtime: "", //结束时间
        activity_istemp: 1, //是否使用招生模板
        activitytemp_id: "", //招生模板id
        activity_tempurl: "", //自定义招生模板链接
        activity_contacttel: "", //联系方式
        activity_codetype: "0",
        package_branch: "",
        activity_address: "", //活动地址
        activity_img: "", //主图
        activity_content: "", //活动详情
        activity_rule: "", //活动规则
        activity_sharedesc: "", //分享描述
        activity_shareimg: "", //分享小图片
        activity_aboutus: "", //关于我们
        activity_customcontent: "", //自定义详情
        frommedia_name: "", //招生渠道类型
        channel_id: "", //招生渠道明细

        activity_issex: 1,
        activity_issex_must: 0,
        activity_isbirthday: 1,
        activity_isbirthday_must: 1,
        activity_isaddress: 1,
        activity_isaddress_must: 0,
      };
      this.imageUrl = "";
      this.imageUrlTwo = "";
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    // 招生渠道类型筛选
    frommediaSearch() {
      this.form.channel_id = "";
      this.getChannelTwoApi(); // 获取渠道明细
    },
    // 选择模板
    selcetTemp() {
      this.form.activity_tempurl = "";
      if (!this.isEdit && this.ActivitytempOption.length > 0) {
        this.form.activitytemp_id = this.ActivitytempOption[0].activitytemp_id;
      } else if (this.isEdit) {
        this.form.activitytemp_id = this.infomationData.activitytemp_id;
        this.form.activity_tempurl = this.infomationData.activity_tempurl;
      }
    },
    loadUeditor(p) {
      (() => {})(p);
    },
    getPromotion(promotion_mobile, index) {
      if (!promotion_mobile) return;
      CrmActiveManage.getPromotion({
        promotion_mobile,
      }).then((res) => {
        if (res.data.code !== 200) {
          this.formData.codeList[index].promotion_name =
            res.data.data.promotion_name;
          this.formData.codeList[index].disabled = true;
          this.$message({
            message: "该手机号已存在",
            type: "error",
          });
        }
      });
    },
    getJobnumber(promotion_jobnumber) {
      if (!promotion_jobnumber) return;
      CrmActiveManage.getPromotion({
        promotion_jobnumber,
      }).then((res) => {
        if (res.data.code !== 200) {
          this.$message({
            message: "该地推工号已存在",
            type: "error",
          });
        }
      });
    },
    // 确定发布
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let promotionList = [...this.promotionSelectList];
          this.formData.codeList.forEach((v) => {
            if (v.promotion_name || v.promotion_mobile) {
              promotionList.push(v);
            }
          });
          let promotion_json = [];
          promotionList.forEach((v) => {
            promotion_json.push({
              promotion_name: v.promotion_name,
              promotion_mobile: v.promotion_mobile,
              promotion_jobnumber: v.promotion_jobnumber,
              promotion_type: v.promotion_type,
              promotion_bankcard: v.promotion_bankcard,
              promotion_bank: v.promotion_bank,
              promotion_id: v.promotion_id || "",
            });
          });
          let data = this.form;
          data.promotion_json = JSON.stringify(promotion_json);

          data["marketer_id"] = this.marketer_id;
          data["token"] = this.token;
          data["school_id"] = this.school_id;
          data["company_id"] = this.company_id;
          if (this.form.activity_istemp == "0") {
            this.form.activitytemp_id = "";
          }

          this.$emit("onSubmit", data);
        }
      });
    },

    ActivityCoursecatApi() {
      storeActive
        .ActivityCoursecatApi({
          adaptive: 1,
          p: 1,
          num: 100000,
          activity_id: this.infomationData.activity_id,
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const { data: classRows, field } = body;
          this.classTableData.options.errortip = msg;
          this.classTableData.columns = field;
          if (code === 200) {
            this.classTableData.list = [...classRows];
          } else {
            this.classTableData.list = [];
          }
        });
    },
    // 切换选项卡
    handleClick(tab, event) {
      (() => {})(tab, event);
      if (this.activeName == "five") {
        this.getGroundPromotion();
      }
      if (this.activeName == "six") {
        this.ActivityCoursecatApi();
        this.$nextTick(() => {
          if (this.$refs["auto_height_class_table"]) {
            this.classTableData.options.tableHeight = this.$Tool.getTableHeight(
              this.$refs.auto_height_class_table.getBoundingClientRect().top +
                75
            );
          }
        });
      }
    },
    getGroundPromotion() {
      storeActive
        .getGroundPromotion({
          open_status: "1",
          activity_id: this.isEdit ? this.infomationData.activity_id : null,
        })
        .then((res) => {
          let columns = res.data.data.field.filter((v) => {
            return v.visible === 1;
          });
          this.promotionTableList.columns = columns;
          if (res.data.code === 200) {
            this.promotionTableList.list = res.data.data.list;
            this.$nextTick(() => {
              this.promotionTableList.list.forEach((row) => {
                this.$refs["promotion"].$children[0].toggleRowSelection(
                  row,
                  !!row.is_Check
                );
              });
            });
          } else {
            this.promotionTableList.list = [];
            this.promotionTableList.options.errortip = res.data.msg;
          }
        });
    },
    addItem() {
      this.formData.codeList.push({
        promotion_name: "",
        promotion_mobile: "",
        promotion_jobnumber: "",
        promotion_type: "0",
        promotion_bankcard: "",
        promotion_bank: "",
      });
    },
    delItem(k) {
      this.formData.codeList.splice(k, 1);
    },
    handleSelectionChange(v) {
      this.promotionSelectList = v;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code === 200) {
        this.form.activity_img = res.data.picture_imgurl;
      }
    },
    // 上传bannner图
    handleAvatarSuccessTwo(res, file) {
      this.imageUrlTwo = URL.createObjectURL(file.raw);
      if (res.code === 200) {
        this.form.activity_shareimg = res.data.picture_imgurl;
      }
      (() => {})(res);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isImg = isJPG || isPNG || isGIF;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("上传头像图片只能是 JPG/PNG/GIF 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }

      return isImg && isLt2M;
    },
  },
};
</script>

<style lang="less">
.slider-activitiesManage {
  .slider-cont .el-tabs__nav {
    padding: 0px;
  }
}
#app .activitiesManage .silder-contain-creat,
#app .activitiesManage .silder-contain-edit {
  .slider-cont {
    padding: 0px 20px 20px 20px;
    .el-form {
      padding: 0px;
    }
    .el-tabs__nav-scroll {
      border-bottom: 0px;
      margin-bottom: 10px;
    }
    .active-time {
      .el-form-item {
        display: inline-block;
        .el-input--medium .el-input__inner {
          padding-left: 30px;
          padding-right: 20px;
        }
      }
      .activity_endtime .el-form-item__content {
        margin-left: 0px !important;
      }
      > span {
        display: inline-block;
        margin: 0 10px;
      }
    }
    // 默认单选按钮样式
    .isdefault {
      margin-left: 10px;
      .el-radio__inner {
        width: 18px;
        height: 18px;
        border: 1px solid #20a8d8;
      }
      .el-radio__input.is-checked .el-radio__inner {
        width: 18px;
        height: 18px;
        background: #fff;
      }
      .el-radio__inner::after {
        background: #20a8d8;
        width: 6px;
        height: 6px;
      }
      .el-radio__original {
        width: 18px;
        height: 18px;
      }
    }
    .tip-text {
      display: inline-block;
      margin: 0 13px;
      color: #d0021b;
      i {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: rgba(210, 11, 36, 1);
        border-radius: 50%;
        font-style: normal;
        color: #fff;
        text-align: center;
        line-height: 20px;
      }
    }
    .uplode-div {
      display: inline-block;
    }
    .el-form .el-form-item__error {
      position: absolute !important;
    }
    .el-form .el-form-item {
      margin-bottom: 20px;
    }
    .upload-share {
      .avatar-share-img {
        .el-upload {
          width: 150px;
          height: 150px;
          background: #f2f2f5;
          border-radius: 8px;
          opacity: 0.9646;
          border: 1px solid #dddddd;
          .share-text {
            padding-top: 22%;
            color: #55606e;
            .el-icon-plus:before {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
  .groundPromotion-manage-tabpane {
    &-wrapper {
      width: 714px;
      .add-icon {
        display: inline-flex;
        cursor: pointer;
        font-size: 14px;
        color: #22a9d7;
        i {
          margin-right: 8px;
          cursor: pointer;
          font-size: 18px;
        }
      }
      .code_list {
        padding: 20px 20px 5px;
        margin-bottom: 20px;
        background: #f7f9fb;
        border-radius: 10px;
        border: 1px solid #eaeef5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .code-remove {
          margin: 8px;
          i {
            cursor: pointer;
            font-size: 24px;
            color: #e1e1e1;
          }
          &:hover {
            opacity: 1;
          }
        }
      }
    }
    &-tips {
      font-size: 13px;
      margin-bottom: 16px;
      color: #f46c6c;
      display: inline-block;
    }
    &-title {
      font-weight: 500;

      font-size: 13px;
      margin: 20px 30px;
      color: #303133;
    }
  }
}
</style>
